// extracted by mini-css-extract-plugin
module.exports = {"categories":"categories__vEGpT","navLinks":"navLinks__30A9n","hoverMenuContainer":"hoverMenuContainer__3kCj1","categoriesMobile":"categoriesMobile__W7BVs"};